import { createContext, useContext, useEffect, useState, type PropsWithChildren } from 'react'

type SegmentedControlProps = PropsWithChildren<{
  id?: string;
  name?: string;
  defaultValue?: string;
  value?: string | null;
  onValueChange?: ( value: string ) => void;
}>;

type SegmentedControlContext = {
  value?: string | null;
  setValue: ( value: string ) => void;
}

const SegmentedControlContext = createContext<SegmentedControlContext>( {
  value: undefined,
  setValue: () => {
    throw new Error( 'Missing SegmentedControlContext provider' )
  }
} )

export const useSegmentedControl = () => useContext( SegmentedControlContext );

export const SegmentedControl = ( { id, children, name, value, defaultValue, onValueChange }: SegmentedControlProps ) => {
  const [ _value, setValue ] = useState<string | undefined | null>( defaultValue ?? value ?? '' );

  useEffect( () => {
    setValue( value ?? '' )
  }, [ value ] )

  return (
    <SegmentedControlContext.Provider value={ {
      value: _value,
      setValue( value: string ) {
        setValue( value );

        if ( typeof onValueChange === 'function' ) {
          onValueChange( value );
        }
      }
    } }>
      {name && (
        <input
          id={ id }
          type={ 'hidden' }
          name={ name }
          value={ _value ?? '' }
        />
      )}
      <div className={ 'border border-[#756BDE] rounded-[10px] flex flex-row overflow-hidden' }>
        {children}
      </div>
    </SegmentedControlContext.Provider>
  )
}
SegmentedControl.displayName = 'SegmentedControl';
